import React from 'react';

const RequiredIcon = () => (
  <svg width={6} height={6}>
    <path
      fill="red"
      d="M2.484.52h1.032l-.124 2.062 1.883-.762.325.964-1.984.538 1.356 1.535-.795.628L3 3.77 1.812 5.485l-.796-.628 1.356-1.535L.4 2.784l.325-.964 1.883.762z"
      fillRule="evenodd"
    />
  </svg>
);

export default RequiredIcon;


// WEBPACK FOOTER //
// ./src/components/Field_Components/RichEditor/Icon/RequiredIcon.js